import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navgationbar from "./Navgationbar";
import Newsletter from "./Newsletter";
import Footer from "./Footer";

export default function Layout() {
    const location = useLocation();
    const shouldRenderNewsletter = location.pathname !== '/login' ;

    return (
        <div className="site-wrapper">
            <Navgationbar />
            <main>
                <Outlet />
            </main>
            {/* {shouldRenderNewsletter && <Newsletter />} */}
            <Footer />
        </div>
    );
}
